
<div class="pageContent py-3 px-4">
  <form [formGroup]="SearchMIForm" class="col-md-12">
    <div class="row">
      <div class="col-md-9">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <ng-container *ngIf="enableSMI || enableReportMI">
              <div *ngIf="enableSMI" class="col-lg-4 col-md-6 col-sm-6">
                <div class="newhexa-logos">
                  <a href="javascript:void(0)" (click)="navigateTo('/find-medical-info')" class="d-flex justify-content-center">
                    <span class="hexagon-fw">
                      Search Medical Information
                    </span>
                  </a>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="newhexa-logos newhexa-logos-2">
                  <a href="javascript:void(0)" (click)="openContactModal(template)" class="d-flex justify-content-center">
                    <span class="hexagon-fw">
                      Call Medical Information
                    </span>
                  </a>
                </div>
              </div>
              <div *ngIf="enableReportMI" class="col-lg-4 col-md-6 col-sm-6">
                <div class="newhexa-logos newhexa-logos-3">
                  <a href="javascript:void(0)" (click)="navigateTo('/request-mi')" class="d-flex justify-content-center">
                    <span class="hexagon-fw">
                      Submit Medical Inquiry
                    </span>
                  </a>
                </div>
              </div>


            </ng-container>

            <ng-container *ngIf="!enableSMI && !enableReportMI">
              <div class="col-md-12 pt-2">
                <div class="row pb-4">
                  <div class="col-md-12 text-center">
                    <p> <span class="fs-16 font-weight-bold"> Welcome to Mallinckrodt Medical Information. </span> To learn more about us, please <a href="javascript:void(0)" class="text-clr pointer texthover text-underline" (click)="route.navigate(['/about-us'])"> click here</a>.</p>
                  </div>
                </div>

                <div class="row pb-2 justify-content-center">
                  <div class="col-lg-4 col-md-6 col-sm-6 br-right1">
                    <div class="newhexa-logos newhexa-logos-2">
                      <a href="javascript:void(0)" (click)="navigateTo('/our-products')" class="d-flex justify-content-center">
                        <span class="hexagon-fw">
                          See Our Products
                        </span>
                      </a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="newhexa-logos newhexa-logos-2">
                      <a href="javascript:void(0)" (click)="navigateTo('/resources')" class="d-flex justify-content-center">
                        <span class="hexagon-fw">
                          See Available Resources
                        </span>
                      </a>
                    </div>
                  </div>

                  <div class="col-md-12 pt-3 br-bt2"> </div>
                </div>

                <div class="row pb-1" *ngIf="isUS_Profile">
                  <div class="col-md-12 text-center">
                    <p class="fs-16 font-weight-bold"> Do you have questions about a Mallinckrodt product? Please call us at: </p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 text-center" *ngIf="isUS_Profile">
                    <p>
                      <a href="javascript:void(0)"><i class="fas fa-phone-square-alt pt-2 px-2 iconstyle"></i></a> <span> 1-800-844-2830 </span>
                      <a href="javascript:void(0)" class="pl-2"><i class="fas fa-clock pt-2 px-2 iconstyle"></i></a> <span> Monday- Friday, 8:00 am- 5:30 pm ET </span>
                    </p>
                  </div>
                  <div class="col-md-12 text-center" *ngIf="!isUS_Profile">
                    <p> <a href="javascript:void(0)"><i class="fas fa-phone-square-alt pt-2 px-2 iconstyle"></i></a> <span class="fs-16 font-weight-bold"> Do you have questions about a Mallinckrodt product? </span> </p>
                    <p class="pt-1 fs-16 font-weight-bold"> Select a region below to view country-specific contact information in alphabetical order for that region. </p>
                  </div>
                </div>
              </div>

              <div class="col-md-12 pt-4" *ngIf="!isUS_Profile">
                <div class="container">

                  <div class="accordion" id="accordionExample">
                    <div class="card">
                      <ng-container *ngFor="let region of Non_US_Regions_List; let i = index;">
                        <div class="card-header" data-toggle="collapse" attr.data-target="#collapseOne_{{i}}" aria-expanded="true">
                          <span class="title"> {{region.name}} </span>
                          <span class="accicon"><i class="fas fa-angle-up rotate-icon"></i></span>
                        </div>
                        <div id="collapseOne_{{i}}" class="collapse" data-parent="#accordionExample">
                          <div class="card-body p-0">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom-table grid-2 border" style="margin: 10px 25px;">
                                  <div class="theader text-center">
                                    <div class="table_header justify-content-center table-border-right">Countries</div>
                                    <div class="table_header justify-content-center">Phone number</div>
                                  </div>
                                  <div class="table-body-wrap">
                                    <div class="table-body dropdownparent tbodyheight-max">
                                      <div class="table_row" *ngFor="let country of region.countriesContacts">
                                        <div class='table_small'>
                                          <div class="table_cell">Countries</div>
                                          <div class="table_cell text-center table-border-right"> {{country.names}} </div>
                                        </div>
                                        <div class="table_small">
                                          <div class="table_cell">Phone number</div>
                                          <div class="table_cell text-center"> {{country.phone}} </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>

                  </div>
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </div>

      <div class="col-md-3">
        <app-promotional-cards></app-promotional-cards>
      </div>
    </div>

  </form>
</div>


<ng-template #template>
  <div class="modal-header">
    <h5 class="modal-title w-100 d-block">
      Contact Us
      <span class="mt-1 float-right fs-13" data-dismiss="modal" (click)="modalRef?.hide()">
        <i class="fas fa-times pointer"></i>
      </span>
    </h5>
  </div>
  <div class="modal-body px-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-md-12">
          <ul class="contactUs">
            <li>
              <div class="row">
                <div class="col-md-12" *ngIf="isUS_Profile">
                  <p>
                    <span class="text-center"><i class="fas fa-phone-alt"></i></span>
                    <small>1-800-844-2830</small>
                  </p>
                  <p><small>Regular Office Hours: Monday to Friday 8:00 am - 5:30 pm ET</small></p>
                </div>

                <div class="col-md-12" *ngIf="!isUS_Profile">
                  <span class="text-center"><i class="fas fa-phone-alt"></i></span>
                  <p> Please locate your country-specific contact number <a href="javascript:void(0)" (click)="openContactDoc('Non-US_Contact_Details.docx', 'Mallinckrodt Contact Details')"> here. </a> </p>
                </div>

                <div class="col-md-12 pt-2" *ngIf="enableReportMI">
                  <span class="text-center"><i class="fas fa-file-medical"></i></span>
                  <a href="javascript:void(0)" class="d-block fs-13" (click)="navigateTo('/request-mi')">
                    Submit a
                    Medical Inquiry
                  </a>
                </div>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>
